export default {
  WEBSITE: 'https://www.yuan365.com',
  WEBSITEINTL: 'https://intl-sit.yuan365.com'
}
